let toastifyCssPromise;

/**
 * Carrega o CSS do react-toastify fora do bundle bloqueante (main.css).
 * Idempotente: a mesma Promise é reutilizada.
 */
export function loadToastifyCss() {
  if (!toastifyCssPromise) {
    toastifyCssPromise = import(
      /* webpackChunkName: "toastify-css" */
      'react-toastify/dist/ReactToastify.css'
    );
  }
  return toastifyCssPromise;
}
